import { Box, ColorOptions, Loader, ModBox, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useCallback, useEffect, useState } from 'react'
import { Dimensions } from 'react-native'
import { ImageWithInfoSerializer } from '../../../comps/ImageWithInfoSerializer/ImageWithInfoSerializer'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { Colors } from '../../../util/util'
import { SearchBar } from '../SearchBar'
import { FavItem } from './FavItem'
import { OperatorItem } from './Item'
import { OperatorSectionList } from './OperatorSectionList'
import styles from './styles'

interface Props {
  hide?: boolean
  title?: string
}

const OperatorList: FC<Props> = ({ hide = true, title }: Props) => {
  const navigation = useNavigation()
  const [searchText, setSearchText] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const {
    getOperatorsList,
    getRecentData,
    getOperatorList,
    getAuthenticatorList,
    updateBillfetchMetaData,
    getBillFetch,
    txnData,
    categoryId,
  } = useStores((root) => ({
    getOperatorsList: root.billPayments?.getOperatorList,
    getRecentData: root.billPayments?.getRecentData,
    getOperatorList: root.billPayments?.getOperatorListApi,
    updateBillfetchMetaData: root.billPayments?.updateBillfetchMetaData,
    category: root.billPayments.transaction?.txnMetaData.category,
    getAuthenticatorList: root.billPayments?.getAuthenticatorListApi,
    getBillFetch: root.billPayments?.getBillFetchApi,
    txnData: root.billPayments?.transaction,
    categoryId: root.billPayments?.transaction?.txnMetaData?.catId,
  }))
  const allOperators = getOperatorsList(categoryId)
  const recentData = getRecentData()

  const [getOperatorsApi, { state: operatorLoading, data: operatorApiData }] = useLazyApiData(getOperatorList)
  const [getAuthenticatorData, { state: authenticatorLoading }] = useLazyApiData(getAuthenticatorList)
  const [getBillAPIFetchData, { state: billfetchLoading }] = useLazyApiData(getBillFetch)

  const callApi = useCallback(() => {
    setIsLoading(true)
    getOperatorsApi()
  }, [getOperatorsApi])

  useEffect(() => {
    if (!hide) {
      callApi()
    }
  }, [callApi, hide])

  useEffect(() => {
    if (operatorLoading === 'rejected' || operatorLoading === 'fulfilled') {
      setIsLoading(false)
      console.log('operatorApiData', operatorApiData)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operatorLoading])

  useEffect(() => {
    if (billfetchLoading === 'fulfilled') {
      const bill = txnData?.txnMetaData?.bill

      if (bill.proceedPaymentFlag && bill.proceedPaymentAlertMsg) {
        //show error
        //setShowAlert({ show: true, message: bill.proceedPaymentAlertMsg })
        navigation.navigate(Routes.BILL_FETCH as never, { title: title } as never)
      } else {
        navigation.navigate(Routes.BILL_FETCH as never, { title: title } as never)
      }
    } else if (billfetchLoading === 'rejected') {
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billfetchLoading, navigation, txnData])

  useEffect(() => {
    if (authenticatorLoading === 'fulfilled') {
      setTimeout(() => {
        setIsLoading(false)
      }, 500)
      navigation.navigate(Routes.AUTH_INPUT as never, { title: title } as never)
    } else if (authenticatorLoading === 'rejected') {
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticatorLoading, navigation])

  if (hide) {
    return null
  }

  const renderSectionHeader = ({ item: sectionItem }: any) => {
    const billerName = sectionItem?.title ?? ''
    return (
      <Box mt={10} pb={0}>
        <Text color={Colors.BLACK_14 as ColorOptions} fontFamily="JioType-Black" fontSize={18} value={billerName} />
      </Box>
    )
  }

  const upadteBillFetchData = (item: any) => {
    setIsLoading(true)
    const auth = item?.authenticators ?? null
    updateBillfetchMetaData({
      billerMasterId: item?.id ?? 0,
      authenticators: auth ? [...auth] : [],
      shortName: item?.shortName ?? '',
    })
    if (item?.authenticators) {
      getBillAPIFetchData()
    } else {
      getAuthenticatorData(item?.id)
    }
  }

  const renderRecentItem = ({ item }: any) => {
    return <FavItem item={item} onPress={upadteBillFetchData} />
  }

  const renderOperatorItem = ({ item }: any) => {
    return <OperatorItem item={item} onPress={upadteBillFetchData} />
  }

  const getSectionData = () => {
    const recentsData = getRecents()
    const operatorData = getOperators()
    // const isAddBillerFlow = status === TransactionStatus.INITIATED_ADD_BILLER

    const retData = []

    if (recentsData.length === 0 && operatorData.length === 0) {
      return []
    }
    //TODO: don't show linked operators
    // if (!isAddBillerFlow && recentsData.length > 0) {
    //   retData.push({ type: 'HEADER', title: 'Linked operators' })
    //   retData.push(...recentsData)
    // }
    if (operatorData.length > 0) {
      retData.push({ type: 'HEADER', title: 'All Operators' })
      retData.push(...operatorData)
    }
    return retData
  }

  const getOperators = () => {
    if (allOperators.length < 1) {
      return []
    }
    const searchFn = (item: any) => {
      const search = searchText.toLowerCase()
      const billerName = item?.title?.toLowerCase()
      return (
        billerName?.includes(search) ||
        item?.searchTags?.split('|')?.some((searchTag: string) => searchTag.toLowerCase().includes(search))
      )
    }
    return allOperators.filter(searchFn)
  }

  const getRecents = () => {
    if (recentData.length < 1) {
      return []
    }
    const searchFn = (item: any) => {
      const search = searchText?.toLowerCase()
      const billerName = item?.title?.toLowerCase()
      const subTitle = item?.shortName && item?.shortName?.toLowerCase()
      const id = item?.authenticators[0] && item?.authenticators[0]?.toLowerCase()
      return billerName?.includes(search) || (subTitle && subTitle.includes(search)) || (id && id.includes(search))
    }
    return recentData.filter(searchFn)
  }

  const onChangeText = (text: string) => {
    setSearchText(text)
  }

  const deviceWidth = Dimensions.get('window').width

  const handleRetry = () => {
    setIsLoading(true)
    getOperatorsApi()
  }
  return (
    <Box f={1}>
      <ModBox show={isLoading} f={1} align="center" justify="center">
        <Loader type={'small'} color="PRIMARY" />
      </ModBox>
      <ModBox f={1} show={!isLoading} {...styles.operatorContainer} alignItems={'center'}>
        <ModBox paddingHorizontal={25}>
          <SearchBar
            onChange={onChangeText}
            hide={operatorLoading !== 'fulfilled'}
            value={searchText}
            placeholder="Search service provider"
            borderRadius={8}
            theme={{ bodyBgColor: '#fff', bodyTextColor: '#B5B5B5' as ColorOptions }}
          />
        </ModBox>
        <ModBox f={1} justify={'center'} align="center" show={operatorLoading === 'rejected'}>
          <ImageWithInfoSerializer
            show={operatorLoading === 'rejected'}
            screenName={
              operatorLoading === 'rejected'
                ? operatorApiData.code === 'ERR0014'
                  ? 'emptyOperatorList'
                  : 'errorOperatorList'
                : 'errorTxn'
            }
            actionButtonVisible={false}
            actionButtonName={'Try Again'}
            onPress={handleRetry}
          />
        </ModBox>
        <ModBox show={operatorLoading === 'fulfilled'} ph={25} f={1} w={deviceWidth} mt={20}>
          <OperatorSectionList
            renderOperatorItem={renderOperatorItem}
            renderRecentItem={renderRecentItem} // TODO: in design there is no linked operator but still display the items
            renderHeader={renderSectionHeader}
            data={getSectionData()}
          />
        </ModBox>
      </ModBox>
    </Box>
  )
}

export { OperatorList }
